var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup33576(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 68,
    viewBox: "0 0 81 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 68,
    fill: "#002766"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0533 36.0667C48.4933 36.6134 48.1733 37.4 48.2533 38.24C48.3733 39.68 49.6934 40.7334 51.1334 40.7334H53.6667V42.32C53.6667 45.08 51.4134 47.3334 48.6534 47.3334H35.1734C35.5867 46.9867 35.9467 46.56 36.2267 46.08C36.72 45.28 37 44.3334 37 43.3334C37 40.3867 34.6133 38 31.6667 38C30.4133 38 29.2533 38.44 28.3333 39.1734V33.3467C28.3333 30.5867 30.5867 28.3334 33.3467 28.3334H48.6534C51.4134 28.3334 53.6667 30.5867 53.6667 33.3467V35.2667H50.9733C50.2267 35.2667 49.5467 35.56 49.0533 36.0667Z",
    stroke: "#7399EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.3333 34.5467V28.4535C28.3333 26.8668 29.3067 25.4534 30.7867 24.8934L41.3733 20.8934C43.0267 20.2667 44.8 21.4935 44.8 23.2668V28.3334",
    stroke: "#7399EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.08 36.6265V39.3733C55.08 40.1066 54.4933 40.7066 53.7467 40.7332H51.1334C49.6934 40.7332 48.3733 39.6799 48.2533 38.2399C48.1733 37.3999 48.4933 36.6132 49.0533 36.0666C49.5467 35.5599 50.2267 35.2666 50.9733 35.2666H53.7467C54.4933 35.2933 55.08 35.8932 55.08 36.6265Z",
    stroke: "#7399EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.3333 34H43.6667",
    stroke: "#7399EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 43.3333C37 44.3333 36.72 45.28 36.2267 46.08C35.9467 46.56 35.5867 46.9867 35.1734 47.3333C34.24 48.1733 33.0133 48.6667 31.6667 48.6667C29.72 48.6667 28.0267 47.6267 27.1067 46.08C26.6133 45.28 26.3333 44.3333 26.3333 43.3333C26.3333 41.6533 27.1067 40.1467 28.3333 39.1733C29.2533 38.44 30.4133 38 31.6667 38C34.6133 38 37 40.3867 37 43.3333Z",
    stroke: "#7399EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5867 43.3334L30.9067 44.6534L33.7467 42.0267",
    stroke: "#7399EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33576);
export default __webpack_public_path__ + "static/media/Group 33576.f278a14de7ad879ab5ea07a74cf201b1.svg";
export { ForwardRef as ReactComponent };